module.exports = __webpack_public_path__ + "img/logo.14da281e.png";